var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Create_New_Order"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Create_New_Order",
    "data-name": "Create New Order",
    clipPath: "url(#clip-Create_New_Order)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9012",
    "data-name": "Group 9012",
    transform: "translate(0.25 0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_255",
    "data-name": "Ellipse 255",
    fill: "#0069bf",
    stroke: "#0081ea",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 10.75,
    r: 10.75,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.75,
    cy: 10.75,
    r: 10.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7987",
    "data-name": "Group 7987",
    transform: "translate(5.76 5.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M317.4,299.691l4.359,1.918v5.838l-4.359,1.691-4.556-1.861.173-5.668Z",
    transform: "translate(-312.647 -299.399)",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M23.244,2.139a.314.314,0,0,0-.195-.291L18.609.024a.315.315,0,0,0-.239,0L13.93,1.848a.314.314,0,0,0-.195.291V7.91a.314.314,0,0,0,.195.291l4.44,1.824a.313.313,0,0,0,.239,0L23.049,8.2a.314.314,0,0,0,.195-.291ZM18.49,3.649l-1.636-.672,3.536-1.542,1.746.717ZM14.364,2.634l1.412.58V4.85a.314.314,0,0,0,.629,0V3.472l1.771.728V9.265L14.364,7.7ZM18.49.654l1.09.448L16.044,2.645l-1.2-.493ZM18.8,4.2l3.812-1.566V7.7L18.8,9.265Z",
    transform: "translate(-13.735 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewOrder);
export default __webpack_public_path__ + "static/media/Create New Order.eaced4e645bdcda683c18c85d37f5b27.svg";
export { ForwardRef as ReactComponent };